
/* Add to cart without leaving the page. One tap adds one item; extra taps while it is
   working are ignored. Updates the header count and shows a small confirmation. */
(function () {
  'use strict';
  if (!window.fetch || !window.FormData) return;

  var css = '.phx-toast{position:fixed;left:50%;bottom:22px;transform:translate(-50%,20px);opacity:0;z-index:70;width:min(420px,calc(100vw - 24px));' +
    'background:#fff;border-radius:14px;box-shadow:0 18px 50px rgba(0,30,80,.3);padding:14px 16px;font-family:Mulish,system-ui,sans-serif;' +
    'transition:opacity .2s,transform .2s;pointer-events:none}' +
    '.phx-toast.on{opacity:1;transform:translate(-50%,0);pointer-events:auto}' +
    '.phx-toast b{display:block;color:#0B2545;font-size:15px;font-weight:800}.phx-toast p{margin:3px 0 12px;font-size:13.5px;color:#4B5563}' +
    '.phx-toast .row{display:flex;gap:8px}.phx-toast a{flex:1;display:flex;align-items:center;justify-content:center;min-height:42px;border-radius:6px;font-weight:800;font-size:14.5px;text-decoration:none}' +
    '.phx-toast .v{background:#fff;color:#003594;box-shadow:inset 0 0 0 2px #003594}.phx-toast .c{background:#FFD23F;color:#0B1F3A}' +
    '.phx-toast.err b{color:#8A5A00}.phx-toast .x{position:absolute;top:8px;right:10px;background:none;border:0;font-size:20px;line-height:1;color:#6B7280;cursor:pointer}' +
    '@media (prefers-reduced-motion:reduce){.phx-toast{transition:none}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var toastEl = null, hideTimer = null;
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function showToast(html, isErr) {
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'phx-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.className = 'phx-toast' + (isErr ? ' err' : '');
    toastEl.innerHTML = '<button class="x" type="button" aria-label="Close">&times;</button>' + html;
    toastEl.querySelector('.x').addEventListener('click', function () { toastEl.classList.remove('on'); });
    void toastEl.offsetWidth; toastEl.classList.add('on');
    clearTimeout(hideTimer); hideTimer = setTimeout(function () { toastEl.classList.remove('on'); }, isErr ? 6000 : 5000);
  }
  function setCount(n) {
    document.querySelectorAll('.phx-cart').forEach(function (a) {
      var c = a.querySelector('.phx-cart-count');
      if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'phx-cart-count'; a.appendChild(c); } c.textContent = n; }
      else if (c) { c.remove(); }
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
    });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var action = f.getAttribute('action') || '';
    if (!/\/cart\/add\/?$/.test(action)) return;
    e.preventDefault();
    if (f.getAttribute('data-busy') === '1') return;
    f.setAttribute('data-busy', '1');
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) { throw d; } return d; }); })
      .then(function (item) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          setCount(cart.item_count);
          var title = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '');
          showToast('<b>Added to your cart</b><p>' + esc(title) + '</p><div class="row"><a class="v" href="/cart">View cart (' + cart.item_count + ')</a><a class="c" href="/checkout">Check out</a></div>');
          if (btn) btn.textContent = 'Added ✓';
        });
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Please try again.';
        showToast('<b>Couldn\'t add that</b><p>' + esc(msg) + '</p>', true);
        if (btn) btn.innerHTML = label;
      })
      .then(function () {
        setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } f.removeAttribute('data-busy'); }, 1200);
      });
  }, true);
})();
